import { type Meta } from '../types/docs';

const META: Meta = {
  description: 'User cancels their transcription edit without saving',
  name: 'transcription_cancel_edit',
};

export default META;
